module.exports = __webpack_public_path__ + "img/img-mathway.5c9167d.png";